import { parseOrThrow } from '@shared/utils/validation-error';
import { z } from 'zod';
import type { Invoice } from '@shared/types';

const FUNCTIONS_BASE_URL = import.meta.env['VITE_FUNCTIONS_BASE_URL'] as string | undefined;

export interface SendDocumentEmailParams {
  to: string;
  subject: string;
  body: string;
  attachmentUrl?: string;
}

const emailParamsSchema = z.object({
  to: z.string().email('宛先のメールアドレスが無効です').refine(
    (v) => !/[\r\n]/.test(v),
    'メールアドレスに無効な文字が含まれています'
  ),
  subject: z.string().min(1, '件名は必須です').refine(
    (v) => !/[\r\n]/.test(v),
    '件名に無効な文字が含まれています'
  ),
  body: z.string().min(1, '本文は必須です'),
  attachmentUrl: z.string().optional(),
});

function getFunctionsBaseUrl(): string {
  if (!FUNCTIONS_BASE_URL) {
    throw new Error('VITE_FUNCTIONS_BASE_URL が設定されていません。');
  }
  return FUNCTIONS_BASE_URL;
}

export async function sendDocumentEmail(params: SendDocumentEmailParams): Promise<void> {
  const validated = parseOrThrow(emailParamsSchema, params);
  const baseUrl = getFunctionsBaseUrl();
  const res = await fetch(`${baseUrl}/sendEmail`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(validated),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '不明なエラー');
    throw new Error(`メール送信に失敗しました: ${text}`);
  }
}

export async function sendInvoiceEmail(
  invoice: Invoice,
  recipientEmail: string,
  message: string
): Promise<void> {
  await sendDocumentEmail({
    to: recipientEmail,
    subject: `【請求書】${invoice.code}`,
    body: message,
  });
}
